// Token Validation Actions
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN';
export const TOKEN_VALID = 'TOKEN_VALID';
export const TOKEN_INVALID = 'TOKEN_INVALID';
export const TOKEN_EXPIRING = 'TOKEN_EXPIRING';
export const SHOW_EXPIRATION_WARNING = 'SHOW_EXPIRATION_WARNING';
export const HIDE_EXPIRATION_WARNING = 'HIDE_EXPIRATION_WARNING';
export const RENEW_TOKEN = 'RENEW_TOKEN';
export const CLEAR_TOKEN_ERROR = 'CLEAR_TOKEN_ERROR';

// Action Creators
export const validateToken = (token) => ({
  type: VALIDATE_TOKEN,
  payload: { token }
});

export const tokenValid = (token, expiresAt) => ({
  type: TOKEN_VALID,
  payload: { token, expiresAt }
});

export const tokenInvalid = (error) => ({
  type: TOKEN_INVALID,
  payload: { error }
});

export const tokenExpiring = (token, expiresAt, timeRemaining) => ({
  type: TOKEN_EXPIRING,
  payload: { token, expiresAt, timeRemaining }
});

export const showExpirationWarning = (timeRemaining) => ({
  type: SHOW_EXPIRATION_WARNING,
  payload: { timeRemaining }
});

export const hideExpirationWarning = () => ({
  type: HIDE_EXPIRATION_WARNING
});

export const renewToken = () => ({
  type: RENEW_TOKEN
});

export const clearTokenError = () => ({
  type: CLEAR_TOKEN_ERROR
});
